import type { HostPlayP2pClientConstructorParams } from '@genially/p2p-client';
import { HostPlayP2pClient } from '@genially/p2p-client';

export const createHostPlayP2pClient = (params: HostPlayP2pClientConstructorParams) => {
  return new HostPlayP2pClient(params);
};
